import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const newPageProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
};

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const publicUrl = process.env.PUBLIC_URL || '';
  // Use PNG with transparency for logo
  const logoSrc = `${publicUrl}/novatrust.PNG`;

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };


  return (
    <header className="fixed top-0 left-0 right-0 z-50 text-white shadow-lg border-b border-[#4d818c]" style={{ background: '#4d818c', height: '64px' }}>
      <div className="w-full h-full flex flex-row items-center justify-between px-2 sm:px-4">
        {/* Logo and Nav in one row for desktop */}
        <div className="flex flex-row items-center h-full flex-shrink-0">
          <div className="flex items-center h-full bg-transparent p-0 m-0 w-28 sm:w-36 lg:w-auto" style={{ height: '64px', minWidth: 'auto' }}>
            <img
              src={logoSrc}
              alt="NovaTrust Logo"
              className="h-24 sm:h-28 lg:h-32 w-auto object-contain bg-transparent"
              style={{ background: 'transparent' }}
            />
          </div>
          {/* Desktop Navigation (right of logo) */}
          <nav className="hidden lg:flex flex-row items-center gap-5 ml-4 h-full">
            <Link to="/" onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Home</Link>
            <Link to="/about" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">About</Link>
            <Link to="/chits" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Chits</Link>
            <Link to="/calculator" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Calculator</Link>
            <Link to="/live-auction" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Live Auction</Link>
            <Link to="/benefits" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Benefits</Link>
            <Link to="/agent" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Become an Agent</Link>
            <Link to="/terms" {...newPageProps} onClick={handleLinkClick} className="text-white font-semibold hover:text-[#ffd600] transition">Terms</Link>
            <Link to="/contact" {...newPageProps} onClick={handleLinkClick} className="rounded-full bg-white px-5 py-2 text-sm font-semibold text-[#4d818c] shadow-lg hover:bg-[#ffd600] hover:text-[#4d818c] transition">Contact</Link>
          </nav>
        </div>
        {/* Call Button aligned right, fill space */}
        <div className="flex flex-1 min-w-0 flex-row items-center justify-end gap-2 lg:gap-4">
          <a href="tel:7755996577" className="flex items-center justify-center bg-white text-[#039be5] font-bold rounded-full px-3 sm:px-6 py-2 shadow hover:bg-[#ffd600] hover:text-[#039be5] transition text-base sm:text-lg" style={{ minWidth: '150px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 mr-2">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 22 2 13.93 2 4.5A1 1 0 013 3.5h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z" />
            </svg>
            7755996577
          </a>
        </div>
        {/* Mobile Menu Button */}
        <button
          type="button"
          className="inline-flex flex-shrink-0 items-center justify-center rounded-full border border-[#ffd600] bg-white p-2 text-[#039be5] shadow-sm transition hover:bg-[#ffd600] hover:text-[#039be5] focus:outline-none focus:ring-2 focus:ring-[#ffd600] lg:hidden ml-1"
          onClick={handleToggle}
          aria-expanded={isOpen}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="sr-only">Toggle navigation</span>
          {isOpen ? (
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18" />
              <path d="M6 6l12 12" />
            </svg>
          ) : (
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 6h16" />
              <path d="M4 12h16" />
              <path d="M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`${isOpen ? 'block' : 'hidden'} lg:hidden bg-slate-900 border-t border-[#D4A574] shadow-lg`}>
        <div className="w-full px-4 py-4 space-y-2">
          <Link to="/" onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Home</Link>
          <Link to="/about" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">About</Link>
          <Link to="/chits" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Schemes</Link>
          <Link to="/calculator" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Calculator</Link>
          <Link to="/live-auction" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Live Auction</Link>
          <Link to="/benefits" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Benefits</Link>
          <Link to="/agent" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Become an Agent</Link>
          <Link to="/terms" {...newPageProps} onClick={handleLinkClick} className="block rounded-xl px-4 py-3 text-white font-semibold hover:bg-slate-800 transition">Terms</Link>
          <Link to="/contact" {...newPageProps} onClick={handleLinkClick} className="block rounded-full bg-[#D4A574] px-5 py-3 text-center text-sm font-semibold text-[#056160] shadow-lg hover:bg-[#c29466] transition">Contact</Link>
        </div>
      </div>
    </header >
  );
};

export default Header;
